import "./App.scss";
import AppRoutes from "./AppRoutes";
import { Providers } from "./Provider";
import { CaseProvider } from "./context/CaseContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Providers>
        <CaseProvider>
          <AppRoutes />
        </CaseProvider>
      </Providers>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;